import React, { Component } from 'react'

class Modal extends Component {
    render() {
        if (!this.props.visible) return null;
        return (
            <div className="modal-drop-container">
                <div id="CenterModal" className="modal fade show" tabIndex="-1" role="dialog" aria-labelledby="CenterModalLabel" style={{ display: 'block', paddingRight: '15px' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            {!!this.props.title &&
                                <div className="modal-header">
                                    <button
                                        onClick={this.props.onClose}
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-hidden="true">×</button>
                                    <h4 className="modal-title" id="CenterModalLabel">{this.props.title}</h4>
                                </div>
                            }
                            <div className="modal-body" style={this.props.style}>
                                {this.props.children}
                            </div>
                            {!this.props.hideActions &&
                                <div className="modal-footer">
                                    <button
                                        onClick={this.props.onClose}
                                        type="button"
                                        className="btn btn-secondary waves-effect"
                                        data-dismiss="modal">CLOSE</button>
                                    <button
                                        onClick={this.props.onActionClick}
                                        type="button"
                                        className="btn btn-info waves-effect waves-light">{this.props.action_text}</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </div>
        )
    }
}

Modal.defaultProps = {
    hideActions: false,
    action_text: "Action"
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal.js